import React from 'react';
export function Prescriptions() {
  return <div className="py-20 bg-white" data-id="element-296">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-297">
        <h1 className="text-4xl font-extrabold text-slate-900 mb-8" data-id="element-298">
          Prescription Services
        </h1>
        <p className="text-lg text-slate-600 mb-12 max-w-3xl" data-id="element-299">
          Manage your health with our comprehensive prescription services. We
          offer easy refills, transfers, and professional consultations.
        </p>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-300">
          <div className="p-8 bg-slate-50 rounded-2xl border border-slate-100" data-id="element-301">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-302">
              Refill a Prescription
            </h2>
            <p className="text-slate-600 mb-6" data-id="element-303">
              Quickly refill your existing prescriptions online for pickup at
              either of our locations.
            </p>
            <button className="bg-clinical-blue text-white font-bold py-3 px-6 rounded-xl hover:bg-blue-700 transition-all" data-id="element-304">
              Start Refill
            </button>
          </div>
          <div className="p-8 bg-slate-50 rounded-2xl border border-slate-100" data-id="element-305">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-306">
              Transfer to Us
            </h2>
            <p className="text-slate-600 mb-6" data-id="element-307">
              Switching to Daily Care Pharmacy is simple. Provide your details
              and we'll handle the rest.
            </p>
            <button className="border-2 border-clinical-blue text-clinical-blue font-bold py-3 px-6 rounded-xl hover:bg-clinical-blue hover:text-white transition-all" data-id="element-308">
              Transfer Now
            </button>
          </div>
        </div>
      </div>
    </div>;
}